import { useEffect, useState } from "react"

import { refreshAos } from "../utils/aos"

export const useAsyncData = (fetcher, deps) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        let active = true
        setLoading(true)
        setError(null)

        fetcher()
            .then((result) => {
                if (active) setData(result)
            })
            .catch((err) => {
                if (active) setError(err)
            })
            .finally(() => {
                if (active) setLoading(false)
            })

        return () => {
            active = false
        }
    }, deps)

    return { data, loading, error }
}

export const useAosOnContent = (content) => {
    useEffect(() => {
        if (!content || (Array.isArray(content) && content.length === 0)) return
        refreshAos()
    }, [content])
}
